import { render, staticRenderFns } from "./CreateFulfillmentForm.vue?vue&type=template&id=e0fbfcf0&scoped=true"
import script from "./CreateFulfillmentForm.vue?vue&type=script&lang=js"
export * from "./CreateFulfillmentForm.vue?vue&type=script&lang=js"
import style0 from "./CreateFulfillmentForm.vue?vue&type=style&index=0&id=e0fbfcf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fbfcf0",
  null
  
)

export default component.exports